import { Pipe, PipeTransform } from '@angular/core';
import { toGps } from 'src/app/utils/number.utils';

@Pipe({
    name: 'gps',
    standalone: false
})
export class GpsPipe implements PipeTransform {
    /**
     * Format to Geographic Coordinate System
     */
    transform(coordinate: number): string {
        if (!coordinate) {
            return null;
        }
        return toGps(coordinate);
    }

}
